import { booleanIntersects } from '@turf/turf';

export const gradientFilter = (filters, item) => {
  if (filters.gradient.length > 0) {
    if (
      !filters.gradient.some((gradient) => {
        if (typeof item.properties.index_main !== 'number') return false;
        return (
          item.properties.index_main >= gradient.min &&
          item.properties.index_main < gradient.max
        );
      })
    ) {
      return false;
    }
  }
  return true;
};

export const polygonsFilter = (filters, item) => {
  if (filters.draw_polygon.length > 0) {
    if (
      !filters.draw_polygon.some((polygon) => booleanIntersects(polygon, item))
    ) {
      return false;
    }
  }
  return true;
};

export const gradientFloodsFilter = (filters, item) => {
  if (filters.gradient.length > 0) {
    if (
      !filters.gradient.some((gradient) => {
        if (typeof item.properties.index !== 'number') return false;
        return item.properties.index === gradient.max;
      })
    ) {
      return false;
    }
  }
  return true;
};
